// extracted by mini-css-extract-plugin
export default {"container":"SocialLinks_container__ZU7W8"};